/** web-account-pages D1, D5 — Profile (`/account/profile`); signed out, the sign-in step in place. Below 768px the app's Profile (D8). */
import { PhoneProfile } from '../../phone/PhoneProfile';
import { Profile } from '../../pieces/profile';
import { useAppScreens } from '../../ui/useIsPhone';
import { usePageTitle } from '../../ui/usePageTitle';
import { SignedInOnly } from './SignedInOnly';

export function ProfilePage() {
  usePageTitle('Profile');
  const phone = useAppScreens();
  return (
    <SignedInOnly>
      {phone ? <PhoneProfile /> : <Profile />}
    </SignedInOnly>
  );
}
